// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"115":"310b0133","394":"5931697a","737":"27556772","850":"7276c1b5","933":"7435ed5f"}[chunkId] + ".css";
};